/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@swimlane/ngx-datatable/release/components/body/scroller.component';
const styles_ScrollerComponent:any[] = ([] as any[]);
export const RenderType_ScrollerComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ScrollerComponent,data:{}});
export function View_ScrollerComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[(_l()(),i0.ɵted(-1,(null as any),['\n    '])),i0.ɵncd((null as any),
      0),(_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(null as any),(null as any));
}
export function View_ScrollerComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'datatable-scroller',
      [['class','datatable-scroll']],[[4,'height','px'],[4,'width','px']],(null as any),
      (null as any),View_ScrollerComponent_0,RenderType_ScrollerComponent)),i0.ɵdid(1,
      245760,(null as any),0,i1.ScrollerComponent,[i0.ElementRef,i0.Renderer],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).scrollHeight;
    const currVal_1:any = i0.ɵnov(_v,1).scrollWidth;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
export const ScrollerComponentNgFactory:i0.ComponentFactory<i1.ScrollerComponent> = i0.ɵccf('datatable-scroller',
    i1.ScrollerComponent,View_ScrollerComponent_Host_0,{scrollbarV:'scrollbarV',scrollbarH:'scrollbarH',
        scrollHeight:'scrollHeight',scrollWidth:'scrollWidth'},{scroll:'scroll'},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3Njcm9sbGVyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvYm9keS9zY3JvbGxlci5jb21wb25lbnQuZC50cyIsIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvbm9kZV9tb2R1bGVzL0Bzd2ltbGFuZS9uZ3gtZGF0YXRhYmxlL3JlbGVhc2UvY29tcG9uZW50cy9ib2R5L3Njcm9sbGVyLmNvbXBvbmVudC5kLnRzLlNjcm9sbGVyQ29tcG9uZW50Lmh0bWwiLCJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL25vZGVfbW9kdWxlcy9Ac3dpbWxhbmUvbmd4LWRhdGF0YWJsZS9yZWxlYXNlL2NvbXBvbmVudHMvYm9keS9zY3JvbGxlci5jb21wb25lbnQuZC50cy5TY3JvbGxlckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxuZy1jb250ZW50PjwvbmctY29udGVudD5cbiAgIiwiPGRhdGF0YWJsZS1zY3JvbGxlcj48L2RhdGF0YWJsZS1zY3JvbGxlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7OztvQkNBQSxxREFDSTtNQUFBLEdBQXlCOzs7b0JDRDdCO01BQUE7TUFBQSw2RUFBQTtNQUFBO01BQUE7SUFBQTs7SUFBQTtJQUFBO0lBQUEsV0FBQSxtQkFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/~/@swimlane/ngx-datatable/release/components/body/scroller.component.ngfactory.ts